import { JsPdfFont, loadFontsJsPdf } from "./module";

const fonts = [
  new JsPdfFont({
    path: `${process.env.VUE_APP_S3_AMAZON_AWS}/assets/fonts/Arabic-Bold.js`,
    variableName: "arabicBoldFont",
    filename: "NotoNaskhArabic-Bold-bold.ttf"
  }),
  new JsPdfFont({
    path: `${process.env.VUE_APP_S3_AMAZON_AWS}/assets/fonts/Arabic-Bold.js`,
    variableName: "arabicBoldFont",
    filename: "NotoNaskhArabic-Bold-bold.ttf",
    customFontName: "Farsi"
  }),
  new JsPdfFont({
    path: `${process.env.VUE_APP_S3_AMAZON_AWS}/assets/fonts/Arabic-Bold.js`,
    variableName: "arabicBoldFont",
    filename: "NotoNaskhArabic-Bold-bold.ttf",
    customFontName: "Urdu"
  })
];

export const downloadFontsJsPdf = async (doc?: any) => await loadFontsJsPdf(fonts, doc);
